import { FC, HTMLProps } from 'react';

export const ChevronDownIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M12.6673 6L8.00065 10.6667L3.33398 6"
        stroke="#202020"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
